module.exports = __webpack_public_path__ + "img/cancelNotification.70def702.svg";